import { render, staticRenderFns } from "./zSplitter.vue?vue&type=template&id=c01befc0&scoped=true&"
import script from "./zSplitter.vue?vue&type=script&lang=js&"
export * from "./zSplitter.vue?vue&type=script&lang=js&"
import style0 from "./zSplitter.vue?vue&type=style&index=0&id=c01befc0&prod&lang=scss&scoped=true&"
import style1 from "./zSplitter.vue?vue&type=style&index=1&id=c01befc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01befc0",
  null
  
)

export default component.exports